/// <amd-module name="VSSUI/Components/FormItem/FormItem" />
import * as React from "react";

import { Observer } from "VSSUI/Observer";
import { css, getSafeId } from "VSSUI/Util";

import { IFormItemContext, IFormItemProps, Severity } from "./FormItem.Props";

export const FormItemContext = React.createContext<IFormItemContext>({});

let formItemId = 1;

export class FormItem extends React.Component<IFormItemProps> {
    private id = "form-item-" + formItemId++;

    public render() {
        const { ariaLabel, className, error, severity, label, message, required } = this.props;
        const ariaLabelledById = label ? this.id + "-label" : undefined;

        return (
            <Observer error={error} severity={severity} message={message}>
                {(observedProps: { error?: boolean | undefined; severity?: Severity, message: React.ReactNode }) => {
                    const ariaDescribedById = observedProps.message ? this.id + "-message" : undefined;

                    return (
                        <FormItemContext.Provider value={{ ariaDescribedById, ariaLabelledById, error: observedProps.error, severity: observedProps.severity }}>
                            <div className={css(className, "flex-column")}>
                                {label && (
                                    <label 
                                        aria-label={ariaLabel} 
                                        className={css(
                                            "bolt-formitem-label",
                                            "body-m",
                                            required && "bolt-formitem-label--required"
                                        )}
                                        id={getSafeId(ariaLabelledById)}
                                    >
                                        {label}
                                    </label>
                                )}
                                {this.props.children}
                                {observedProps.message && (
                                    <span
                                        className= {css("bolt-formitem-message body-xs",
                                        observedProps.error && (!severity || severity === Severity.Error) && "bolt-formitem-message-error",
                                        observedProps.error && severity === Severity.Warning && "bolt-formitem-message-warning")}
                                        id={getSafeId(ariaDescribedById)}
                                        role={observedProps.error ? "alert" : undefined}
                                    >
                                        {observedProps.message}
                                    </span>
                                )}
                            </div>
                        </FormItemContext.Provider>
                    );
                }}
            </Observer>
        );
    }
}
